
import './App.css';
import './configs/muiProLicense';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import { SnackbarProvider } from 'notistack';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { RouterProvider } from 'react-router-dom';

import { useLanguageSync } from './hooks/useLanguageSync';
import { FreyrLibraryProvider } from './lib/freyr-react-common/context/FreyrLibraryContext';
import { useSnackbarDomRoot } from './lib/snackbarDomRoot';
import router from './routes';
import { getMuiLocale } from './utils/muiLocale';
const token = Cookies.get('ACCESS_TOKEN');
const queryClient = new QueryClient();

// Portal snackbars into a fullscreen element when one is active so that toasts
// remain visible while a descendant uses the native Fullscreen API.
const AppSnackbarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const domRoot = useSnackbarDomRoot();
  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      domRoot={domRoot ?? undefined}
    >
      {children}
    </SnackbarProvider>
  );
};

function App() {

  const { i18n } = useTranslation();
  // sync language from global config
  useLanguageSync();

  const theme = useMemo(
    () => {
      const locales = getMuiLocale(i18n.language);
      return createTheme({}, ...locales);
    },
    [i18n.language]
  );
  return (
    <FreyrLibraryProvider token={token} language={i18n.language} >
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <AppSnackbarProvider>
            <RouterProvider router={router} />
          </AppSnackbarProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </FreyrLibraryProvider>
  );
}

export default App;
